module.exports = __webpack_public_path__ + "img/arena-473.7ae9b141.png";